import { render } from "./recicladoMasivo.vue?vue&type=template&id=2e8a5ba0&scoped=true"
import script from "./recicladoMasivo.vue?vue&type=script&lang=js"
export * from "./recicladoMasivo.vue?vue&type=script&lang=js"

import "./recicladoMasivo.vue?vue&type=style&index=0&id=2e8a5ba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8a5ba0"]])

export default __exports__